export default {"aBC": "(a)+(b)+(c)",
  "aboutUs": "About Us",
  "accountDetail": "Detalle de la cuenta",
  "accountStatus": "Estado de cuenta",
  "action": "Acción",
  "active": "Activo",
  "activeConsumesLicense": "Activo (consume licencia)",
  "activateDriver": "Activar conductor",
  "activateDriverTooltip": "El conductor consumirá una licencia.",
  "activateCar": "Activar coche",
  "activateCarTooltip": "El coche consumirá una licencia.",
  "activities": "Actividades",
  "activity": "Actividad",
  "activityTime": "tiempo de actividad",
  "activityTimes": "Tiempos de actividad",
  "adddriver": "Añadir conductor",
  "addLicences": "Añadir licencias",
  "addNewAddresses": "Añadir nuevas direcciones",
  "addNewAudits": "Añadir nuevas auditorías",
  "addNewBookletPage": "Añadir nuevo folleto",
  "addnewcardriver": "Asignar conductor",
  "addNewCarDriver": "Asignar conductor",
  "addNewCars": "Añadir coches nuevos",
  "addNewClients": "Añadir nuevo conjunto de frabicantes",
  "addNewConfig": "Nueva configuración",
  "addNewContractItens": "Añadir Nuevos Itens de Contrato",
  "addNewContracts": "Nuevos contratos",
  "addNewDrivercar": "Añadir nuevo coche de conductor",
  "addNewDriverCar": "Agregar Nuevo Conductor",
  "addNewDrivers": "Añadir nuevos conductores",
  "addNewFleets": "Añadir nuevas flotas",
  "addNewItens": "Añadir nuevos itens",
  "addNewLists": "Añadir nuevas listas",
  "addNewPermDriver": "Agregar Nuevo Conductor",
  "addNewPermiDriver2": "Añadir nuevo conductor Permi2",
  "addNewPermiFleet2": "Añadir nueva flota Permi2",
  "addNewPermissions": "Nuevos permisos",
  "addNewProducts": "Añadir nuevos servicios",
  "addNewReports": "Agregar nuevos informes",
  "addNewReportsLog": "Agregar nuevos informes",
  "addNewRequests": "Nuevas solicitudes",
  "addNewTabledisplaylabel": "Añadir nuevo ${TableDisplayLabel}",
  "addNewUserdriver": "Añadir nuevo controlador de usuario",
  "addNewUsers": "Añadir nuevos usuarios",
  "address": "Dirección",
  "addresses": "Direcciones",
  "addressesAddress": "Direcciones Dirección",
  "addressesCep": "Direcciones Cep",
  "addressesCity": "Destinatarios",
  "addressesClient": "Direcciones del cliente",
  "addressesContact": "Direcciones Contacto",
  "addressesContracts": "Direcciones Contratos",
  "addressesDateCreated": "Direcciones Fecha de creación",
  "addressesDateUpdated": "Fecha de actualización de direcciones",
  "addressesDetail": "Detalle de direcciones",
  "addressesDetails": "Detalles de direcciones",
  "addressesDriver": "Direcciones del conductor",
  "addressesDrivers": "Direcciones de los conductores",
  "addressesEmail": "Correo electrónico de direcciones",
  "addressesL1": "Direcciones L1",
  "addressesL2": "Direcciones L2",
  "addressesLocality": "Domicilios Localidad",
  "addressesNifNipc": "Direcciones Nif Nipc",
  "addressesObs": "Direcciones Obs",
  "addressesPhone": "Direcciones Teléfono",
  "addressesReference": "Referencia de direcciones",
  "addressesReviewedBy": "Direcciones revisadas por",
  "addressesState": "Estado de las direcciones",
  "addressesSystem": "Sistema de direcciones",
  "admin": "Administrador",
  "admission": "Ingreso",
  "agreeTerms": "Debes estar de acuerdo con:",
  "allRightsReserved": "Todos los derechos reservados",
  "alreadyExist": "ya existe",
  "alreadyHaveAnAccount": "¿Ya tiene una cuenta?",
  "alterarAosDadosDeAcessoSomentePeloProprioUtilizador": "Alterar aos dados de acesso somente pelo propio utilizador",
  "anual": "Anual",
  "application": "Aplicación",
  "aquivado": "Aquivado",
  "arquivada": "Arquivada",
  "arquivadas": "Arquivadas",
  "arquivado": "Arquivado",
  "archiveDriver": "Archivo de la tarjeta de conductor",
  "archiveDriverTooltip": "El socio de la App ya no consumirá una licencia y puede reactivarse en cualquier momento.",
  "archiveCar": "Archivar coche",
  "archiveCarTooltip": "El vehículo ya no consumirá una licencia y se puede reactivar en cualquier momento.",
  "replaceCar": "Reemplazar coche",
  "replaceCarTooltip": "Reemplaza este auto por uno nuevo, transfiriendo todas las asignaciones de conductores.",
  "replaceCarSubmit": "Confirma reemplazo de íconos",
  "replacementInfo": "Información de sustitución",
  "oldCarRegister": "Anterior alta",
  "replacementDriverWarning": "Todos los conductores asignados a este coche serán transferidos al nuevo coche.",
  "replacementSummary": "Resumen de sustitución",
  "replacementDetails": "Detalles del reemplazo",
  "oldCar": "Coche anterior",
  "newCar": "Un nuevo coche",
  "driverAssignmentsUpdated": "Asignaciones de Socios Conductores actualizadas",
  "replacementProcessing": "Procesamiento de reemplazo...",
  "ativa": "ACTIVA ",
  "ativas": "Ativas",
  "atividade": "Atividade",
  "ativo": "Ativo",
  "ativosLicenas": "Ativos/LicenÃ§as",
  "atLeastOneCarRequired": "El conductor necesita al menos un vehículo asignado para registrar las actividades.",
  "atribuidoAosCondutores": "Atribuido aos condutores",
  "audits": "Auditorías",
  "auditsDetails": "Detalles de las auditorías",
  "available": "Disponible",
  "availablePlural": "Disponibles",
  "assignedPlural": "Asignados",
  "Available": "Disponible",
  "Drive": "Tracción",
  "Pause": "Pausa",
  "Rest": "Descanso",
  "Other work": "Otros trabajos",
  "Other job": "Otro empleo",
  "Otherwork": "Otros trabajos",
  "Otherjob": "Otro empleo",
  "availColor": "Avail Color",
  "back": "Atrás",
  "birth": "Nacimiento",
  "blocked": "Bloqueado",
  "bookletPage": "Página del folleto",
  "bookletPageDetails": "Detalles de la página del folleto",
  "brand": "Marca",
  "browse": "Explorar…",
  "button": "Botón",
  "calender": "Calender",
  "cancel": "Cancelar",
  "capitalLetter": "Mayúscula",
  "car": "Coche",
  "cars": "Automóviles",
  "carsBookletPage": "Página del folleto de coches",
  "carsBrand": "Marca de coches",
  "carsCar": "Coches Coche",
  "carsClient": "Cliente de Cars",
  "carsDateCreated": "Fecha de creación",
  "carsDateUpdated": "Fecha de actualización",
  "carsDetail": "Detalle de coches",
  "carsDetails": "Detalles del coche",
  "carsDrivercar": "Coches Conductorcoche",
  "carsFleet": "Flota de coches",
  "carsModel": "Modelo de coches",
  "carsRegister": "Registro de coches",
  "carsRegisterDate": "Fecha registro",
  "carsStatus": "Estado de los coches",
  "category": "Categoría",
  "cc": "Cc",
  "cep": "CEP",
  "changeEmail": "Cambiar dirección de correo electrónico",
  "changepass": "changepass",
  "changepassword": "ChangePassword",
  "changePassword": "Cambiar contraseña",
  "changeYouPassword": "Cambiar tu contraseña",
  "charactersMinimum": "8 caracteres como mínimo",
  "checkingAvailability": "Comprobando disponibilidad",
  "chooseFilesOrDropFilesHere": "Elija archivos o suelte archivos aquí",
  "city": "Ciudad",
  "clickHereToLogin": "Haz clic aquí para iniciar sesión",
  "client": "Cliente",
  "clientactivecontracts": "Clientactivecontracts",
  "clientContract": "Contrato de clientes",
  "clientContractDetails": "Detalles del contrato del cliente",
  "clientcontracts": "clientContracts",
  "clientName": "Nombre del cliente",
  "clientorders": "clientOrders",
  "clientRequests": "Solicitudes para clientes",
  "clients": "Clientes",
  "clientsActivity": "Actividad de clientes",
  "clientsAddresses": "Direcciones de clientes",
  "clientsClient": "Clientes: cliente 3",
  "clientsDateCreated": "Clientes Fecha de creación",
  "clientsDateUpdated": "Fecha de actualización de clientes",
  "clientsDetail": "Detalle de clientes",
  "clientsDetails": "Detalles del cliente:",
  "clientSince": "Cliente desde:",
  "clientsLicense": "Licencia de clientes",
  "clientsLogo": "Logotipo del cliente",
  "clientsName": "Nombre del Cliente: ______________________",
  "clientsNipc": "Clientes Nipc",
  "clientsObs": "Clientes Obs",
  "clientsProduct": "Producto de clientes",
  "clientsReviewedBy": "Clientes revisados por",
  "clientsStatus": "Estado de los clientes",
  "close": "Cerrar",
  "closed": "Cerrado",
  "code": "Codi",
  "color": "Color",
  "condutores": "Condutores",
  "condutoresAtivos": "Condutores ativos",
  "condutoresNaAplicaoDriverEGerentesNaFleet": "Condutores na aplicaÃ§£o  'driver' e Gerentes na 'fleet'.",
  "condutoresNaAplicaoDriverEGerentesNaFleetOAcessoPoderSerRealizadoNoNomeDoUtilizador": "Condutores na aplicaÃ§£o  'driver' e Gerentes na 'fleet'.  O Acesso poderá ser realizado no nome do Utilizador",
  "config": "Config",
  "configDetails": "Detalles de la configuración",
  "configParameter": "Parámetro de configuración",
  "confirmNewPassword": "Confirmar nueva contraseña",
  "confirmPassword": "Confirmar nueva contraseña",
  "confirmTheRequest": "(Para confirmar el pedido)",
  "confirmTheRequestYouWillReceiveAnEmailWithPaymentDetailsLicenseActivationWillOccurAfterPaymentConfirmation": "Confirma la solicitud. Recibirás un correo electrónico con los datos de pago. La activación de la licencia se producirá después de la confirmación del pago.",
  "congratulations": "¡Enhorabuena!",
  "contact": "Contacto",
  "contactEmail": "Correo Electrónico de Contacto",
  "contactSystemAdmin": "Póngase en contacto con el administrador del sistema para obtener más información.",
  "contactUs": "Contacte con nosotros",
  "continue": "Continuar",
  "connectivity": {
    "online": "API en línea",
    "offline": "Sin acceso",
    "connecting": "Comprobando conexión...",
    "noConnection": "No se pudo acceder al servidor",
    "needInternet": "Sin conexión a Internet o falla temporal de la red.",
    "reconnected": "Acceso al servidor restaurado",
    "yourIpIs": "Su IP de acceso:",
    "restrictedAccess": "Acceso restringido",
    "regionalRestrictionInfo": "Detectamos que su acceso proviene de una dirección de red (IP) con restricciones de seguridad.",
    "whatToDo": "¿Qué hacer?",
    "contactSupportWithIp": "Desactive cualquier VPN, Proxy o Firewall que pueda estar simulando una ubicación fuera de Portugal e intente nuevamente. Si el problema persiste, póngase en contacto con el soporte proporcionando la IP a continuación."
  },
  "network": {
    "online": "API en línea",
    "offline": "Sin acceso",
    "noConnection": "No se pudo acceder al servidor",
    "needInternet": "Sin conexión a Internet o falla temporal de la red.",
    "reconnected": "Acceso al servidor restaurado",
    "yourIpIs": "Su IP de acesso:",
    "tapToRetry": "Sin conexión. Toque aquí para volver a intentarlo.",
    "retrying": "Conectando... estabilizando conexión"
  },
  "contract": "Contrato",
  "contractItens": "Contract Itens",
  "contractItensDetails": "Detalles del contrato Itens",
  "contractRenewd": "Renovación del contrato",
  "contracts": "Contratos",
  "contractsAddress": "Dirección de contratos",
  "contractsClient": "Contratos Cliente",
  "contractsContract": "Contratos Contrato",
  "contractsContractItens": "Contratos Contrato Itens",
  "contractsDateActivated": "Fecha de activación de los contratos",
  "contractsDateCreated": "Fecha de creación de los contratos",
  "contractsDateDeactivated": "Fecha de desactivación de los contratos",
  "contractsDateDue": "Fecha de vencimiento de los contratos",
  "contractsDateIssued": "Fecha de emisión de los contratos",
  "contractsDatePayed": "Fecha de pago de los contratos",
  "contractsDateUpdated": "Fecha de actualización de los contratos",
  "contractsDetail": "Detalle contratos",
  "contractsDetails": "Contratos - detalles",
  "contractsInvoice": "Factura de contratos",
  "contractsObs": "Contracts Obs",
  "contractsPayment": "Pago de contratos",
  "contractsPermalink": "Contratos Permalink",
  "contractsProduct": "Contratos Producto",
  "contractsRequest": "Solicitud de contratos",
  "contractsReviewedBy": "Contratos examinados",
  "contractsStatus": "Estado de los contratos",
  "contrata": "CONTRATA",
  "contratoDeTrabalho": "Contrato de trabalho",
  "createRecord": "Crear Nuevo Registro",
  "cttItem": "Artículo Ctt",
  "cttitensduedate": "Cttitensduedate",
  "currentPassword": "Contraseña actual",
  "dadosDeContatatoNoAlteraAcessoDoCondutor": "Dados de contatato (nÃ£o altera acesso do condutor)",
  "dadosDeContato": "Dados de contato",
  "dadosParaCadastroDoCondutor": "Dados para catastro do condutor",
  "dadosParaCadastroDoUtilizador": "Dados para catastro do utilizador",
  "dark": "oscuro",
  "dataImportedSuccessfully": "Datos importados correctamente",
  "date": "Fecha",
  "dateActivated": "Fecha de activación",
  "dateCreated": "Fecha de creación",
  "dateDeactivated": "fecha desactivado",
  "dateDue": "Fecha límite",
  "dateFrom": "Fecha Desde",
  "dateIssued": "Fecha de emisión",
  "datePayed": "Fecha de pago",
  "dateTo": "Fecha Hasta",
  "dateUpdated": "Fecha de actualización",
  "dateValidity": "Fecha de validez",
  "day": "Día",
  "defaultcar": "Coche predeterminado",
  "delete": "Eliminar",
  "deleteAccount": "Eliminar cuenta",
  "deleteRecord": "Eliminar registro",
  "deleteSelected": "Eliminar elemento seleccionado",
  "deleteThisRecord": "Eliminar este registro",
  "description": "Descripción",
  "discount": "Descuento",
  "dontHaveAnAccount": "¿No Tiene Cuenta?",
  "drive": "Tracción",
  "driveA": "Galería A",
  "driveColor": "Color de la unidad",
  "driver": "Impulsor",
  "driverActivities": "Actividades del conductor",
  "driverCalendar": "Calendario del conductor",
  "driverCalendarDetails": "Detalles del calendario del conductor",
  "drivercar": "Drivercar",
  "drivercarDetails": "Detalles del coche del conductor",
  "drivers": "Conductores",
  "driversAdmission": "Admisión de conductores",
  "driversBirth": "Nacimiento de conductores",
  "driversCategory": "Categoría de conductores",
  "driversClient": "Drivers Client",
  "driversDateCreated": "Fecha de creación de los Socios Conductores",
  "driversDateUpdated": "Fecha de actualización de los socios de la App",
  "driversDetail": "ES Idle Drivers Detail",
  "driversDetails": "Detalles del conductor",
  "driversDriver": "Conductores Conductores",
  "driversDriverCalendar": "Calendario de Socios Conductores",
  "driversDrivercar": "Conductores Conductores de coches",
  "driversEmail": "Correo electrónico de los conductores",
  "driversHomeAddress": "Dirección de residencia de los socios de la App",
  "driversLicense": "Licencia de conducir",
  "driversName": "Nombre del conductor",
  "driversNif": "Drivers Nif",
  "driversObs": "Drivers Obs",
  "driversSelfemployed": "Conductores autónomos",
  "driversStatus": "Estado de los conductores",
  "statusFiledPending": "Archivados y Migrados",
  "driverTransferredMessage": "Este usuario está en otra empresa. Para regresar, debe ser archivado en la empresa actual y proceder como un nuevo registro.",
  "driversWrkAddress": "Dirección Wrk de los conductores",
  "driversWrkFone": "Drivers Wrk Fone",
  "duration": "Duración",
  "eachNewLicenseAdds1OneVehicleAnd1OneDriver": "Cada nueva licencia añade 1 (un) vehículo y 1 (un) conductor.",
  "edit": "Editar",
  "editAccount": "Editar cuenta",
  "editAddresses": "Editar direcciones",
  "editar": "Editar",
  "editBookletPage": "Editar página de folleto",
  "editCars": "Editar coches",
  "editClients": "Editar colección de fabricantes",
  "editConfig": "Editar configuración",
  "editContractItens": "Editar Itens de Contrato",
  "editContracts": "Editar contratos",
  "editDrivercar": "Editar Drivercar",
  "editDrivers": "Editar conductores",
  "editFleets": "Editar flotas",
  "editItens": "Editar Itens",
  "editLists": "Editar Listas",
  "editMyAccount": "Editar mi cuenta",
  "editPermDriver": "Editar conductor permanente",
  "editPermiDriver2": "Editar conductor Permi2",
  "editPermiFleet2": "Editar flota Permi2",
  "editPermissions": "Editar permisos",
  "editProducts": "Editar productos",
  "editReports": "Editar informes",
  "editReportsLog": "Editar informes",
  "editTabledisplaylabel": "Editar ${TableDisplayLabel}",
  "editThisRecord": "Editar este registro",
  "editUserdriver": "Editar Userdriver",
  "editUsers": "Editar Usuarios",
  "email": "Correo Electrónico",
  "emailAddressChanged": "Correo electrónico cambiado correctamente",
  "emailAddressNotRegistered": "Esta dirección de correo electrónico no está registrada",
  "emailAddressVerified": "Su dirección de correo electrónico ya está verificada.",
  "emailNotChanged": "Correo electrónico no modificado",
  "emailOrPhoneNumber": "Correo electrónico o Número de teléfono",
  "emailVerificationCompleted": "Verificación de correo electrónico completada.",
  "emailVerificationResent": "Se ha reenviado la verificación del correo electrónico",
  "emailVerificationSent": "Enlace de verificación de correo electrónico enviado",
  "emailVerifiedAt": "Correo Electrónico Verificado",
  "endDate": "Fecha de fin",
  "endDay": "Día de finalización",
  "endKm": "Km Final",
  "endTime": "Hora de fin",
  "enterAccountStatus": "Introduce el estado de la cuenta",
  "enterActivity": "Introduzca la actividad",
  "enterAdmission": "Ingrear Fecha de Ingreso Pago Incorporación",
  "enterAgreeTerms": "Introducir términos de acuerdo",
  "enterApplication": "introduzca el ID de la aplicación",
  "enterAvailColor": "Introducir color de disponibilidad",
  "enterBirth": "Introducir nacimiento",
  "enterBrand": "Introduzca la marca",
  "enterCar": "Introducir coche",
  "enterCategory": "Introducir categoría",
  "enterCc": "Introducir CC",
  "enterCep": "Introducir Cep",
  "enterCity": "Introduzca la ciudad",
  "enterClient": "Ingrese el nombre del cliente",
  "enterClosed": "Entrar cerrado",
  "enterCode": "Ingresar código",
  "enterConfigParameter": "Introducir parámetro de configuración",
  "enterContact": "Entrar en contacto",
  "enterContactEmail": "Ingrese el email de contacto.",
  "enterContractRenewd": "Introducir renovación de contrato",
  "enterDateActivated": "Introduzca la fecha de activación",
  "enterDateDeactivated": "Introduzca la fecha de desactivación",
  "enterDateDue": "Fecha de vencimiento",
  "enterDateFrom": "Entrar fecha",
  "enterDateIssued": "Introduzca la fecha de emisión",
  "enterDatePayed": "Introduzca la fecha de pago",
  "enterDateTo": "Introducir fecha hasta",
  "enterDateValidity": "Introduzca la fecha de validez",
  "enterDescription": "Ingresar Descripción",
  "enterDiscount": "Introduzca el descuento",
  "enterDriveColor": "Introduzca el color de la unidad",
  "enterDriver": "Introduzca el nombre del conductor",
  "enterDrivers": "Introducir Socios Conductores",
  "enterEmail": "Introducir e-mail",
  "enterEmailVerifiedAt": "Introduzca el correo electrónico verificado en",
  "enterEndKm": "Introducir Km final",
  "enterFielddisplaylabel": "Introduzca ${FieldDisplayLabel}",
  "enterFleet": "Introducir flota",
  "enterFormat": "Ingresar formato de fecha",
  "enterFpasschange": "Introducir Fpasschange",
  "enterFuelLiters": "Introduzca litros de combustible",
  "enterHomeAddress": "Introduzca la dirección de residencia completa.",
  "enterIncome": "Introducir ingresos",
  "enterInvoice": "Crear Factura",
  "enterIva": "Introducir Iva",
  "enterL1": "Introducir L1",
  "enterL2": "Introducir L2",
  "enterLabel": "Escribe la etiqueta",
  "enterLicense": "Introducir licencia",
  "enterLicenses": "Introducir licencias",
  "enterLocality": "Introducir localidad",
  "enterLog": "Introducir registro",
  "enterLogo": "Introducir el logotipo",
  "enterManagerEmailOk": "Introduzca el correo electrónico del gerente Aceptar",
  "enterManagerNameOk": "Ingrese Nombre Gerente",
  "enterManagerTelOk": "Introduzca el teléfono del gerente OK",
  "enterMaxCars": "Introduzca Max",
  "enterMaxDrivers": "Introduce el número máximo de socios de la App",
  "enterMaxFleets": "Introducir Flotas Máximas",
  "enterModel": "Ingrese el modelo",
  "enterName": "Nombre",
  "enterNif": "Introducir Nif",
  "enterNifNipc": "Entra en Nif Nipc",
  "enterNipc": "Entra en Nipc",
  "enterNipcNifOk": "Introduzca Nipc Nif Ok",
  "enterObs": "Introducir Obs",
  "enterOjobColor": "Introducir color de Ojob",
  "enterOtherExpense": "Introducir otro gasto",
  "enterOtp": "Ingrese la contraseña de un solo uso",
  "enterOworkColor": "Introducir color Owork",
  "enterPassword": "Enter Password",
  "enterPauseColor": "Introducir color de pausa",
  "enterPayment": "Ingresa pago",
  "enterPermalink": "Introducir enlace permanente",
  "enterPermission": "Ingrese el código de permiso",
  "enterPhone": "Teléfono",
  "enterPrice": "Ingresar precio",
  "enterProduct": "Ingresar producto:",
  "enterPvp": "Introducir Pvp",
  "enterQuantity": "Introduzca la cantidad",
  "enterReference": "Introducir referencia...",
  "enterRegister": "INGRESA/REGISTRATE",
  "enterRegisterDate": "Introduzca la fecha de registro",
  "enterReviewedBy": "Introducir revisado por",
  "enterSelfemploed": "Introducir autónomo",
  "enterSelfemployed": "Introduzca Trabajador por cuenta propia",
  "enterStartKm": "Introducir Km de inicio",
  "enterState": "Provincia ",
  "enterStatus": "Entrar en estado de",
  "enterSystem": "Ingresar al Sistema",
  "enterText": "Introducir texto",
  "enterTheCode": "Introducir el código",
  "enterTimeallowance": "Introducir tiempo permitido",
  "enterTo": "registrar",
  "enterType": "Ingrese el tipo",
  "enterUnit": "Ingresar Unidad",
  "enterUser": "Insertar Usuario",
  "enterUserName": "Introducir nombre de usuario",
  "enterUserRoleId": "Ingresa el ID de Usuario",
  "enterValue": "Introduce valor",
  "enterWrkAddress": "Introduzca la dirección Wrk",
  "enterWrkFone": "Introduzca Wrk Fone",
  "errorDeletingRecord": "Error al eliminar el registro. Asegúrese de que el registro salga",
  "errorInsertingRecord": "Error al insertar un nuevo registro de datos.",
  "errorProcessingRequest": "Error al procesar la solicitud",
  "errorRegisteringUser": "Se ha producido un error al registrar el usuario",
  "errorSendingEmail": "Error al enviar el correo electrónico. Póngase en contacto con el administrador del sistema para obtener más información",
  "errorUploadingFile": "Error al cargar el archivo",
  "excluir": "Excluir",
  "export": "Exportar",
  "exportCsv": "Exportar CSV",
  "exportExcel": "Exportar a Excel",
  "exportPageFields": "Exportar campos de página",
  "exportWord": "Exportar a Word",
  "failedJobs": "Trabajos fallidos",
  "false": "false",
  "filed": "Presentación",
  "filedNotConsumesLicense": "Archivado (no consume licencia)",
  "fileFormatNotSupported": "No se acepta el formato de archivo.",
  "filename": "Nombre de archivo",
  "files2": "==========Files2==========",
  "filterByStatus": "Filtrar por estado",
  "fleet": "Transporte",
  "fleetManager": "Gerente de flota",
  "fleets": "Flotas",
  "fleetsApplication": "Aplicación de flotas",
  "fleetsCars": "Flotas Coches",
  "fleetsClient": "Cliente de flotas",
  "fleetsDetail": "Detalle de flotas",
  "fleetsDetails": "Detalles de flotas",
  "fleetsFleet": "´Flotas&amp;apos;, &amp;apos;Flota&amp;apos;.",
  "fleetsName": "Nombre de flotas",
  "format": "Formato",
  "formIsInvalid": "El formulario es invalido",
  "fpasschange": "Fpasschange",
  "fpasswordchange": "fpasswordchange",
  "fuelLiters": "Litros de combustible",
  "geolocations": "Geolocalizaciones",
  "helpAndFaq": "Ayuda y preguntas frecuentes",
  "hi": "Hola",
  "home": "Inicio",
  "homeAddress": "Domicilio principal",
  "id": "Id",
  "importData": "Importar datos",
  "incio": "InÃ­cio",
  "income": "Ingresos",
  "invalidCaptchaCode": "Código Captcha inválido",
  "invalidEmailVerifyLink": "El enlace de verificación de correo electrónico no es válido",
  "invalidRequest": "Solicitud no válida",
  "invoice": "Factura",
  "item": "Elementos",
  "itens": "Artículos",
  "itensDetails": "Detalles de Itens",
  "iva": "IVA",
  "l1": "L1",
  "l2": "L2",
  "label": "Etiqueta",
  "language": "Lenguaje",
  "lastCarAccessed": "último coche al que se accedió",
  "latitude": "Latitud",
  "license": "Licencia",
  "licenses": "Licencias",
  "limit": "Límite",
  "line": "Line",
  "listaddress": "Lista de ubicaciones",
  "listdrivers": "Listdrivers",
  "listfleet": "Lista de flotas",
  "lists": "Listas",
  "listsDetails": "Detalles de las listas",
  "loading": "Cargando...",
  "loadMore": "Cargar Más",
  "locality": "Localidad",
  "log": "Log",
  "logId": "ID de registro",
  "login": "Iniciar sesión",
  "loginCompleted": "Inicio de sesión completado",
  "logo": "Logo",
  "logoff": "notificación de baja",
  "logout": "Cerrar sesión",
  "longitude": "Longitude",
  "manager": "Gerente",
  "managerEmailOk": "Gestor de correo electrónico",
  "managerNameOk": "Nombre del manager",
  "managerTelOk": "Gerente Tel. Ok",
  "maxCars": "Máximo de Vehículos ",
  "maxDrivers": "Máximo de controladores",
  "maxFleets": "Flotas máximas",
  "migrations": "Migraciones",
  "model": "Modelo",
  "myAccount": "Mi cuenta",
  "mycompany": "MiEmpresa",
  "myplan": "MyPlan",
  "timezone": "Huso horario (emisión de informes)",
  "name": "Nombre",
  "nenhumRegistroEncontrado": "Ningúno registro encontrado",
  "newPassword": "Nueva contraseña",
  "newValues": "Valores nuevos",
  "nif": "NIF",
  "nifNipc": "Nif Nipc",
  "nipc": "Nipc",
  "nipcNifOk": "Nipc Nif Ok",
  "no": "NÃ£o",
  "noFileSelectedForUpload": "Ningún archivo seleccionado para cargar",
  "noMoreContentToLoad": "No hay más contenido que cargar",
  "noRecordFound": "Nuk u gjet asnjë rekord",
  "noRecordInserted": "Registro introducido",
  "noRecordUpdated": "No hay registros actualizados",
  "noRequestFound": "No se encontró ninguna solicitud",
  "notAvailable": "No disponible",
  "number": "Número",
  "oAcessoAoSistemaPodeSerRealizadoPeloNomeDoUtilizador": "O acesso ao sistema pode ser realizado pelo nome do utilizador.",
  "oauthAccessTokens": "Tokens de acceso Oauth",
  "oauthAuthCodes": "Códigos de autenticación de Oauth",
  "oauthClients": "OAuth Clients",
  "oauthPersonalAccessClients": "Clientes de acceso personal de Oauth",
  "oauthRefreshTokens": "Tokens de actualización de Oauth",
  "obs": "Obs.",
  "of": "de",
  "ojobColor": "Color de Ojob",
  "oldValues": "Valores antiguos",
  "ordaerDate": "Fecha de Ordaer",
  "order": "Ordenar",
  "orderDate": "Fecha del pedido",
  "orderUpdated": "Orden actualizado",
  "otherExpense": "Otros gastos",
  "otherJob": "Otro empleo",
  "otherJobC": "Otro trabajo (c)",
  "otherWork": "Otro trabajo",
  "otherWorkB": "Otros trabajos (b)",
  "otpSentEmail": "OTP se ha enviado a su correo electrónico",
  "otpSentSMS": "Se ha enviado OTP a su número de teléfono a través de SMS",
  "otpVerification": "Verificación de OTP",
  "oUtilizadorDeveAlterarNoDriverOuNoFleetOsDadosDeAcesso": "O utilizador deve alterar no 'driver' ou no 'fleet' os dados de acesso.",
  "oworkColor": "Color Owork",
  "page": "Página",
  "password": "Contraseña",
  "passwordChangedMsg": "Su contraseña ha sido cambiada con éxito",
  "passwordHint": "Sugerencias : no menos de 6 caracteres",
  "passwordReset": "Restablecer contraseña",
  "passwordResetKeyFailure": "'Error al restablecer la contraseña',",
  "passwordResetLinkMsg": "Se le enviará un enlace a su correo electrónico que contiene la información que necesita para su contraseña",
  "passwordResetMsg": "Se ha enviado un mensaje a tu correo electrónico. Por favor, siga el enlace para restablecer su contraseña",
  "passwordResets": "Restablecimiento de contraseñas",
  "passwordResetStepsMsg": "Por favor, intente restablecer su contraseña siguiendo estos pasos",
  "pauseColor": "Color de pausa",
  "payment": "Pago",
  "pendente": "Migrado",
  "pendenteAguardaRevisoActivoEmCobrana": "Pendente: Aguarda revisÃ£o / Activo: em cobranÃ§a",
  "pendenteAguardaRevisoAtivoEmCobrana": "Pendente: Aguarda revisÃ£o / Ativo: em cobranÃ§a",
  "pendentes": "Pendientes",
  "pending": "Migrado",
  "permalink": "Enlazar",
  "permDriver": "Conductor permanente",
  "permDriverDetails": "Detalles del controlador",
  "permiadmin2": "Permiadmin2",
  "permiDriver2": "Conductor Permi2",
  "permiDriver2Details": "Detalles de Permi Driver2",
  "permiFleet": "Flota Permi",
  "permiFleet2": "Permi Fleet2",
  "permiFleet2Details": "Detalles de Permi Fleet2",
  "permission": "Autorización",
  "permissionId": " Id Permiso",
  "permissions": "Permisos",
  "permissionsDetails": "Detalles de permisos",
  "permiVendas2": "Permi Vendas2",
  "permiVendas3": "Permi Vendas3",
  "phone": "Teléfono",
  "phoneNumber": "Número de teléfono",
  "photo": "Foto",
  "places": "Lugares",
  "pleaseAChooseFile": "Por favor elija un archivo",
  "pleaseCompleteTheForm": "Por favor complete el formulario.",
  "pleaseEnterText": "Por favor, introduzca texto",
  "pleseConfirmTheRequest": "Plese confirma la solicitud.",
  "price": "Precio",
  "print": "Imprimir",
  "printPageSettings": "Imprimir configuración de página",
  "printPdf": "Imprimir PDF",
  "privacyPolicy": "Política de privacidad",
  "product": "Producto",
  "productName": "Nombre del producto",
  "products": "Productos",
  "productsClients": "Productos Clientes",
  "productsDetail": "Detalle de productos",
  "productsDetails": "Detalles de Productos",
  "promptAccountBlocked": "Su cuenta ha sido bloqueada.",
  "promptAccountCreated": "Se ha creado tu cuenta. ",
  "promptAccountInReview": "Tu cuenta está pendiente de revisión",
  "promptAccountNotActive": "Tu cuenta no está activa. Póngase en contacto con el administrador del sistema para obtener más información",
  "promptDeleteRecord": "¿Está seguro de que quiere eliminar este registro?",
  "promptDeleteRecords": "¿Está seguro de que quiere eliminar estos registros?",
  "promptEmailNotRegistered": "La dirección de correo electrónico o NIF no está registrada en el sistema",
  "promptForValidEmail": "Proporcione el correo electrónico o NIF válido que utilizó para registrarse",
  "promptPasswordConfirmFail": "La confirmación de tu contraseña no es coherente",
  "promptPasswordExpired": "Tu contraseña ha caducado. Restablece tu contraseña para continuar.",
  "promptPasswordResetFailed": "No se ha completado el restablecimiento de tu contraseña",
  "provideNewPassword": "\"Proporcione una nueva contraseña. ",
  "pvp": "PVP",
  "quantity": "Cantidad",
  "recordAddedSuccessfully": "Registro agregado exitosamente",
  "recordDeletedSuccessfully": "Registro(s) eliminado con éxito.",
  "recordId": "Id de registro",
  "records": "Archivos",
  "recordUpdatedSuccessfully": "Registro actualizado correctamente",
  "reference": "Referencia",
  "registaParaUtilizar": "Regístrate para usar",
  "register": "Caja registradora",
  "registerDate": "Fecha registro",
  "registroExcludoComSucesso": "Registro excluÃ­do com sucesso",
  "rememberMe": "Recuérdame",
  "removePageLinks": "Eliminar enlaces de página",
  "removerAtribuio": "Remover atribuiÃ§Ã£o",
  "report": "Notificar",
  "reports": "Informes",
  "reportsDetails": "Detalles de los informes",
  "reportsLog": "Registro de informes",
  "reportsLogDetails": "Detalles del registro de informes",
  "request": "Solicitar",
  "requestInProcess": "Solicitud de marcación en proceso",
  "requestInProcessing": "Solicitud en proceso.",
  "requests": "Solicitudes",
  "requestsContracts": "Solicita contratos",
  "requestsDetail": "Detalle Solicitudes",
  "requestUrl": "URL de la solicitud",
  "resendEmail": "Reenviar mensaje de correo electrónico",
  "resetcookies": "Restablecer Cookies",
  "resetPassword": "Restablecer contraseña",
  "forgotPassword": "¿Olvidó su contraseña?",
  "rest": "Descanso",
  "reverse": "Reversa",
  "reviewedBy": "Revisado por",
  "roleId": "Rol",
  "roleName": "Nombre del rol",
  "roles": "Funciones",
  "rolesadmin": "Rolesadmin",
  "rolesDetail": " Detalle de Roles",
  "rolesPermissions": "Roles y Permisos",
  "rolesUsers": "Roles Usuarios",
  "savePng": "Guardar PNG",
  "saving": "Guardando...",
  "search": "Buscar",
  "settings": "Configuración",
  "selectAFileToImport": "Seleccione un archivo para importar",
  "selectAValue": "Seleccionar %s",
  "selectPaperSize": "Seleccione el tamaño del papel",
  "selfemploed": "Autónomo",
  "selfemployed": "Autoempleados",
  "send": "Enviar",
  "shouldContain": "La fecha límite para presentar propuestas es 16.08.2002.",
  "showHeader": "Mostrar encabezado",
  "sim": "<g id=\"109\"></g>Sim",
  "somenteContatato": "somente contatato:",
  "somenteDadosDeContatatoNoAlteraAcessoDoCondutor": "Somente dados de contatato (nÃ£o altera acesso do condutor:",
  "sortBy": "Ordenar Por",
  "startDate": "Fecha de inicio",
  "startDay": "Día de inicio",
  "startEnd": "Inicio/Fin",
  "startEndDetails": "Detalles de inicio y finalización",
  "startKm": "Km de inicio",
  "startTime": "Hora de inicio",
  "state": "Provincia",
  "status": "Sincronizar el estado de confirmación de la reserva con el pedido Woo correspondiente",
  "statusDuration": "Duración del estado",
  "submit": "Enviar",
  "success": "Realizado con éxito",
  "supportedFileTypes": "Tipos de archivo compatibles",
  "symbol": "Símbolo",
  "system": "Sistema",
  "tabledisplaylabelDetails": "${TableDisplayLabel} Detalles",
  "temCertezaDeQueDesejaExcluirEsteRegistro": "¿Tem certeza de que deseja excluir este registro?",
  "termsAndConditions": "Terms and Conditions",
  "teste": "teste novo",
  "text": "Texto",
  "theDashboard": "El Panel de control",
  "thisPageIsForNewDriversOnlyToTransferAnExistingDriverPleaseContactSupport": "Esta página es solo para nuevos conductores. Para transferir un socio de la App existente, comunícate con el equipo de",
  "timeallowance": "Tiempo permitido",
  "timestamp": "Timestamp",
  "to": "Hasta",
  "total": "Total actual de tropas",
  "totalHoursDay": "Total horas al día",
  "totalValue": "Valor total",
  "totalWorkingHours": "Horas de trabajo totales",
  "trabalhadorPorContaPropria": "Trabalhador por conta propia",
  "trmino": "Término",
  "true": "Verdadero",
  "tstatus": "tstatus",
  "type": "Tipo",
  "unableToConnect": "No se pudo establecer la conexión...",
  "unableToCompleteRequest": "No se puede completar la solicitud",
  "developedBy": "Solución desarrollada por Fusão Eterea - Unip. Lda., &copy; 2025",
  "unit": "Unidad",
  "unitiCost": "Coste Uniti",
  "update": "Actualiza",
  "updateRecord": "Actualizar Registro",
  "user": "Usuario",
  "userAgent": "User Agent",
  "userdriver": "Userdriver",
  "userdriverDetails": "Detalles del controlador de usuario",
  "userId": "Id del Usuario",
  "userIp": "IP de Usuario",
  "userLogin": "Ingreso de Usuario",
  "username": "Nombre de usuario",
  "userName": "nombre de usuario",
  "usernameEmailPhoneNumber": "Nombre de usuario / correo electrónico /número de teléfono",
  "usernameOrEmail": "Correo electrónico o NIF",
  "usernameOrPasswordNotCorrect": "El nombre de usuario o la contraseña no son correctos.",
  "usernameOrPhoneNumber": "Nombre de usuario o número de teléfono",
  "userRegistration": " Alta Usuario",
  "userRoleId": "Id de rol de usuario",
  "users": "Usuarios",
  "usersDetails": "Detalles de usuarios",
  "value": "Valor",
  "vdsRequests": "Solicitudes de VDS",
  "verify": "Verificar",
  "verifyEmailLinkMsg": "Por favor, verifique su dirección de correo electrónico siguiendo el enlace en su buzón de correo",
  "view": "Visualización",
  "viewMore": "ver más",
  "viewRecord": "Ver el registro",
  "viso": "VisÃ£o",
  "vnculo": "VÃ­nculo",
  "week": "Semana",
  "weekstartdate": "Weekstartdate",
  "welcome": "Le damos la bienvenida",
  "wrkAddress": "Dirección Wrk",
  "wrkFone": "Wrk Fone",
  "wsday": "Wsday",
  "youNeedToLogInAgain": "Es necesario volver a iniciar sesión",
  managerPage: {
    welcomeTitle: "¡Bienvenido a Livrete Fleet!",
    welcomeDescription: "Esta es su plataforma de gestión como operador de transporte.<br><br>Aquí, podrá crear y gestionar conductores y vehículos, asignar qué conductores pueden conducir determinados vehículos, monitorizar las actividades de todos los conductores y generar informes para gestión e inspección.<br><br><strong>Registre su primer vehículo.</strong>",
    doNotShowAgain: "No volver a mostrar",
    paymentReferenceTitle: "Referencia de pago",
    paymentDataTitle: "Datos de pago",
    paymentInstruction: "Utilice estos datos para completar el cobro.",
    method: "Método",
    entity: "Entidad",
    reference: "Referencia",
    amount: "Valor",
    validUntil: "Válido hasta",
    guidelinesDrivers: "Pautas - Conductores",
    driversWithoutCarAlert: "Hay ${count} conductores sin vehículo asignado. Revíselos y asígnelos para evitar bloqueos operativos.",
    guidelinesCars: "Pautas - Vehículos",
    carsWithoutDriverAlert: "Hay ${count} vehículos activos sin conductor asignado. Revíselos y asígnelos para evitar bloqueos operativos.",
    guidelinesContracts: "Pautas - Contratos",
    contractsDueAlert: "Hay ${count} contratos caducados o que caducan en los próximos 30 días.",
    contractLabel: "Contrato",
    validity: "vigencia",
    waitBillingRenewal: "Espere el cobro para pagar la renovación.",
    expiresTodayWaitBilling: "Caduca hoy. Espere el cobro para pagar la renovación.",
    expiresInDaysWaitBilling1: "Caduca en ${days} día.",
    expiresInDaysWaitBilling: "Caduca en ${days} días.",
    guidelinesBillings: "Pautas - Cobros",
    activeBillingsAlert: "Hay ${count} cobros activos para contratos. Haga clic en método/validez para ver los datos de pago.",
    suspendedPaymentAlert: "Referencia suspendida, pero puede ser pagada en cualquier momento para reactivar su plan.",
    warnFiledDrivers: "Atención: Licencias (${lic}) - Activos (${act}) - Conductores del contrato (${ctr}) = ${bal}. Al vencer este contrato, todos los conductores activos serán archivados.",
    warnFiledCars: "Atención: Licencias (${lic}) - Vehículos activos (${act}) - Vehículos del contrato (${ctr}) = ${bal}. Al vencer este contrato, todos los vehículos activos serán archivados.",
    cars: "Vehículos",
    activeLicensesCars: "Activos/Licencias",
    startManagingFleet: "¡Prepárate para gestionar tu flota como nunca!",
    manageFleetDescription: "Aquí, controlarás vehículos, conductores, monitorizarás actividades de conducción y trabajo del equipo, y generarás informes esenciales.<br><strong>¿Empezamos?</strong> Sigue estos sencillos pasos:<br>1. <strong>Registra tu primer vehículo:</strong> Ingresa todos los datos requeridos.<br>2. <strong>Registra tu primer conductor:</strong> Rellena la información solicitada y asigna los vehículos que puede usar.",
    wantIncreaseCars: "¿Quieres aumentar el número de vehículos?",
    changePlan: "Cambiar plan",
    fleets: "Flotas",
    groupCarsToFacilitate: "Agrupar vehículos para facilitar la gestión",
    drivers: "Conductores",
    activeLicensesDrivers: "Activos/Licencias",
    noDriversRegistered: "No hay conductores registrados",
    registerFirstDriverText: "<strong>Registra tu primer conductor:</strong> Rellena la información solicitada y asigna los vehículos que puede usar.",
    wantIncreaseDrivers: "¿Quieres aumentar el número de conductores?",
    workLocations: "Lugares de trabajo",
    manageWorkLocations: "Gestiona los lugares de trabajo de tus conductores",
    contractInRenewal: "Contrato en renovación",
    request: "Petición",
    paymentMethod: "Forma de pago",
    type: "Tipo: ${method}",
    ok: "Ok"
  },
  myPlanPage: {
    cancelRequestTitle: "Confirmación",
    cancelRequestMsg: "¿Desea cancelar esta solicitud pendiente?",
    requestCanceled: "Solicitud cancelada con éxito.",
    buyMoreLicenses: "Compre más licencias.",
    request: "Solicitud",
    pendingRequestAlert: "Hay una solicitud pendiente.",
    cancel: "Cancelar",
    settings: "Configuración",
    timezone: "Zona Horaria (Timezone)",
    contractRenewal: "Renovación de Contrato",
    cancelRenewalLabel: "No quero renovar más ninguno de mis contratos",
    cancelRenewalHelp: "Al activar esta opción, todos sus contratos activos dejarán de renovarse automáticamente y los servicios serán interrumpidos tras sus respectivas fechas de vencimiento.",
    confirmCancelRenewalTitle: "No Renovar Todos los Contratos",
    confirmCancelRenewalMsg: "¿Está seguro de que no desea renovar todos sus contratos automáticamente?<br><br>Si lo confirma, el servicio será interrumpido al finalizar la vigencia de cada contrato activo.",
    confirmCancelRenewalOk: "Sí, no renovar contratos",
    confirmCancelRenewalCancel: "No, mantener contratos activos",
    renewalOptionUpdated: "Opción de renovación de contrato actualizada."
  },
  carsPage: {
    onboardingTitle: "¡Prepárese para gestionar su flota como nunca!",
    onboardingDesc: "Aquí, usted controlará vehículos, conductores, monitoreará actividades de conducción y trabajo del equipo, y generará informes esenciales.",
    letsStart: "¿Empezamos?",
    followSteps: "Siga estos sencillos pasos:",
    step1Title: "Registre Su Primer Vehículo:",
    step1Desc: "Introduzca todos los datos obligatorios.",
    step2Title: "Registre Su Primer Conductor:",
    step2Desc: "Rellene la información solicitada y asocie los vehículos que puede utilizar.",
    assignCar: "Asignar Vehículo",
    assignCarsCount: "Asignar Vehículos (${count})",
    selectDriverFirst: "Seleccione un conductor antes de asignar vehículos.",
    carAssignedSuccess: "¡Vehículo(s) asignado(s) con éxito!"
  },
  driversPage: {
    yes: "Sí",
    no: "No",
    noDriverRegisteredTitle: "Sin Conductor Registrado",
    noDriverRegisteredDesc: "¿Organizaremos su flota? Antes de añadir un conductor, asegúrese de que el vehículo que utiliza ya esté debidamente registrado en el sistema.",
    assignDriver: "Asignar Conductor",
    assignDriversCount: "Asignar Conductores (${count})",
    selectCarFirst: "Seleccione un vehículo antes de asignar conductores.",
    driverAssignedSuccess: "¡Conductor(es) asignado(s) con éxito!",
    availableDrivers: "Conductores Disponibles"
  },
  connectivity: {
    restrictedAccess: "Acceso Restringido",
    regionalRestrictionInfo: "Hemos detectado que su acceso proviene de una dirección de red (IP) con restricciones de seguridad.",
    whatToDo: "¿Qué hacer?",
    contactSupportWithIp: "Por favor, contacte con el soporte técnico y proporcione su IP pública para solicitar acceso.",
    yourIpIs: "Su IP es:"
  },
  network: {
    online: "API Online",
    offline: "sin acceso",
    noConnection: "No se pudo acceder al servidor",
    needInternet: "Sin conexión a internet o fallo temporal de red.",
    reconnected: "Acceso al servidor restablecido",
    yourIpIs: "Su IP de acceso:",
    "tapToRetry": "Sin conexión. Toque aquí para verificar la red.",
    retrying: "Conectando... estabilizando conexión"
  },
  copy: "Copiar",
  goToHomePage: "Volver a la página de inicio",

  suspensaoDeContrato: "Suspensión de Renovación",
  processandoPedido: "Procesando su solicitud...",
  tokenNaoFornecido: "Token de validación no proporcionado.",
  tokenErroDesc: "Por favor, utilice el enlace recibido en el correo electrónico de cobro.",
  suspensaoEfetuada: "¡Renovación Suspendida con Éxito!",
  suspensaoSucessoDesc: "La renovación automática de este contrato ha sido cancelada. Ya no recibirá correos de cobro relativos a este período.",
  erroAoSuspender: "No se pudo suspender la renovación.",
  tentarNovamente: "Intentar De Nuevo",
  confirmarCancelamentoDesc: "Al confirmar, el contrato no se renovará automáticamente al final del período activo actual.",
  confirmarNaoRenovacao: "No quiero renovar el contrato",

	validations: {
		required: "Value is required.",
		undefined: "Value is required.",
		email: "Value is not a valid email address",
		minLength: "This field should be at least ${min} characters long",
		maxLength: "The maximum length allowed is ${max}",
		minValue: "The minimum value allowed is ${min}",
		maxValue: "The maximum value allowed is ${max}",
		numeric: "Value must be numeric",
		ipAddress: "The value is not a valid IP address",
		sameAs: "The value must be equal to the ${otherName} value",
	}
}
